import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideZonelessChangeDetection } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpInterceptor } from "@app/interceptor/http-interceptor";
import { BrandTranslateCompiler } from "@app/shared/compilers/brand-translate-compiler";
import { MergeTranslateLoader } from "@app/shared/loaders/merge-translate-loader";
import { environment } from "@environments/environment";
import { provideTranslateService, TranslateCompiler, TranslateLoader } from "@ngx-translate/core";
import { createErrorHandler, TraceService } from "@sentry/angular";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";

export const getLocalStorage = (): Storage | null => {
  return typeof window !== 'undefined' ? window.localStorage : null;
};

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      RecaptchaV3Module,
    ),
    provideTranslateService({
      loader: { provide: TranslateLoader, useFactory: (http: HttpClient) => new MergeTranslateLoader(http, './assets/i18n/', '.json'), deps: [HttpClient] },
      compiler: { provide: TranslateCompiler, useClass: BrandTranslateCompiler },
    }),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([HttpInterceptor])),
    { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
    { provide: ErrorHandler, useValue: createErrorHandler({ showDialog: false }) },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
  ],
}